<template>
  <div class="detailed-table-tab">
    <!-- Loader -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-layout justify-space-between mb-3>
      <h2>Filtrer</h2>
      <v-spacer></v-spacer>
      <v-btn class="mr-6" @click="handlePrint">
        Exporter le tableau affiché
      </v-btn>
    </v-layout>

    <!-- Filters Block -->
    <v-layout class="filters-container" mb-8 wrap>
      <v-flex sm12>
        <v-layout>
          <v-flex sm4>
            <v-select
              :items="dateTypes"
              label="Année"
              filled
              hide-details
              v-model="dateType"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-data-table
      v-if="!isLoading"
      :headers="headers"
      :items="filteredProjects"
      fixed-header
      height="500"
    >
      <template #group.header="{ group, items }">
        <td class="text-start" colspan="6">{{ group }}</td>
        <td class="text-start">
          Opération en cours pour applicateur : {{ items.length }}
        </td>
        <td class="text-start">
          Total montant devis :
          {{ calculateTotalQuotation(items) | currency }}
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import utils from "@/mixins/utils";

  import PrintRepository from "@/repositories/print";
  import ProjectsRepository from "@/repositories/projects";

  export default {
    name: "DetailedTableTab",
    mixins: [utils],
    data() {
      return {
        isLoading: false,

        // Datatable headers
        headers: [
          {
            text: "Applicateur",
            align: "left",
            value: "applicator_fullname"
          },

          {
            text: "Janvier",
            align: "left",
            value: "january"
          },
          {
            text: "Fevrier",
            align: "left",
            value: "february"
          },
          {
            text: "Mars",
            align: "left",
            value: "march"
          },
          {
            text: "Avril",
            align: "left",
            value: "april"
          },
          {
            text: "Mai",
            align: "left",
            value: "may"
          },
          {
            text: "Juin",
            align: "left",
            value: "june"
          },
          {
            text: "Juillet",
            align: "left",
            value: "july"
          },
          {
            text: "Août",
            align: "left",
            value: "august"
          },
          {
            text: "Septembre",
            align: "left",
            value: "september"
          },
          {
            text: "Octobre",
            align: "left",
            value: "october"
          },
          {
            text: "Novembre",
            align: "left",
            value: "november"
          },
          {
            text: "Décembre",
            align: "left",
            value: "december"
          }
        ],

        projects: [],

        // Search
        dateFrom: null,
        dialogDatepickerFrom: false,
        dateTo: null,
        dialogDatepickerTo: false,

        dateType: "OPERATIONS_IN_PROGRESS",

        dateTypes: [
          {
            value: "OPERATIONS_IN_PROGRESS",
            text: "Opérations en cours"
          }
        ]
      };
    },
    computed: {
      // Add props to project item
      filteredProjects() {
        return this.projects.map(item => {
          item.applicator_fullname = `${item.applicator_lastname.toUpperCase()} ${
            item.applicator_firstname
          }`;

          item.patient_fullname = `${item.patient_lastname} ${item.patient_firstname}`;

          return item;
        });
      }
    },
    methods: {
      /**
       * Search projects by date range
       */
      async onSearch() {
        const options = {
          dateFrom: this.dateFrom || null,
          dateTo: this.dateTo || new Date().toISOString().split("T")[0]
        };

        const { data } = await ProjectsRepository.fetchInProgressProjects(
          options
        );
        this.projects = data;
      },

      /**
       * Sum prop value in an array of items
       *
       *  @param {Array} items
       */
      calculateTotalQuotation(items) {
        return items.reduce(
          (a, b) => a + (b.total_amount_ht_lomaco_quotation || 0),
          0
        );
      },

      // Print project and medias
      async handlePrint() {
        const params = {
          dateFrom: this.dateFrom || null,
          dateTo: this.dateTo || new Date().toISOString().split("T")[0]
        };

        try {
          const res = await PrintRepository.getInProgressPdf(params);
          let blob = new Blob([res], {
            type: "application/pdf"
          });

          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);

          link.download = "encours.pdf";
          link.click();
        } catch (error) {
          console.error(error);
        }
      }
    },
    async mounted() {
      this.isLoading = true;
      const { data } = await ProjectsRepository.fetchInProgressProjects();
      this.projects = data;
      this.isLoading = false;
    }
  };
</script>

<style lang="scss">
  .detailed-table-tab {
    .v-data-table__wrapper {
      height: 470px !important;
    }
    .total {
      p {
        text-align: right;
        color: #006064;
        font-weight: bold;
        font-size: 15px !important;
      }
    }
  }
</style>
